import React, { Component } from 'react';

import { hot } from 'react-hot-loader/root';

import CannyRouter from 'common/core/CannyRouter';

import WebviewRoutes from './WebviewRoutes';

import 'css/webview.scss';

class WebviewApp extends Component {
  render() {
    const { history } = this.props;
    return <CannyRouter history={history} routes={WebviewRoutes} />;
  }
}

export default hot(WebviewApp);
